import { render, staticRenderFns } from "./ModalOsAVencer.vue?vue&type=template&id=30818092&scoped=true&"
import script from "./ModalOsAVencer.vue?vue&type=script&lang=js&"
export * from "./ModalOsAVencer.vue?vue&type=script&lang=js&"
import style0 from "./ModalOsAVencer.vue?vue&type=style&index=0&id=30818092&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30818092",
  null
  
)

export default component.exports